module.exports = __webpack_public_path__ + "img/tab08.9ea67d2e.png";